import { MenuItem, MenuItems } from "../types";

const getLeavesFromNode = (menuItem: MenuItem): MenuItems => {
  if (menuItem.children === null) {
    return [menuItem];
  }

  const leaves: MenuItems = [];
  for (const item of menuItem.children) {
    leaves.push(...getLeavesFromNode(item));
  }
  return leaves;
};

export const getOnlyChildObjects = (menuItems: MenuItems): MenuItems => {
  const allLeaves: MenuItems = [];
  for (const item of menuItems) {
    allLeaves.push(...getLeavesFromNode(item));
  }
  return allLeaves;
};
